import { isStringNullOrWhiteSpace } from 'owa-strings';
import { SubstrateSearchSuggestionsResponsePeopleSuggestion } from 'owa-search-service';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { getStore } from '../store/store';

export default function convertSuggestionToPersonaType(
    suggestion: SubstrateSearchSuggestionsResponsePeopleSuggestion,
    returnMaskedRecipients?: boolean
) {
    const emailAddress = suggestion.EmailAddresses ? suggestion.EmailAddresses[0] : null;

    if (!returnMaskedRecipients && getStore().sessionMaskedRecipients[emailAddress]) {
        return null;
    }

    const emailAddressWrapper = {
        EmailAddress: emailAddress,
        Name: isStringNullOrWhiteSpace(suggestion.DisplayName)
            ? suggestion.Text
            : suggestion.DisplayName,
        MailboxType: getMailboxType(suggestion.PeopleSubtype),
        RoutingType: getRoutingType(suggestion.PeopleSubtype),
        ItemId: suggestion.PDLItemId
            ? { Id: suggestion.PDLItemId, __type: 'ItemId:#Exchange' }
            : null,
    };
    const findRecipientPersonaType: FindRecipientPersonaType = {
        EmailAddress: emailAddressWrapper,
        EmailAddresses: [emailAddressWrapper],
        DisplayName: suggestion.DisplayName,
        PersonaTypeString: getPersonaTypeString(suggestion.PeopleSubtype),
        ADObjectId: suggestion.ADObjectId,
        PersonaId: { Id: suggestion.PersonaId },
        FeatureData: suggestion.FeatureData,
        Id: suggestion.Id,
    };

    return findRecipientPersonaType;
}

function getRoutingType(contactType: string) {
    if (contactType == 'PersonalDistributionList') {
        return 'MAPIPDL';
    }
    return 'SMTP';
}

function getPersonaTypeString(contactType: string) {
    switch (contactType) {
        case 'PublicDistributionList':
        case 'PersonalDistributionList':
            return 'DistributionList';
        case 'UnifiedGroup':
            return 'ModernGroup';
        case 'OrganizationUser':
        case 'PersonalContact':
        case 'ImplicitContact':
        case 'OrganizationContact':
            return 'Person';
        case 'LinkedIn':
            return 'LinkedIn';
        case 'ImplicitGroup':
            return 'ImplicitGroup';
        default:
            return 'Unknown';
    }
}

function getMailboxType(contactType: string) {
    switch (contactType) {
        case 'PublicDistributionList':
            return 'PublicDL';
        case 'PersonalDistributionList':
            return 'PrivateDL';
        case 'UnifiedGroup':
            return 'GroupMailbox';
        case 'ImplicitGroup':
            return 'RecommendedGroup';
        case 'OrganizationUser':
            return 'InternalMailbox';
        case 'LinkedIn':
            return 'LinkedIn';
        case 'PersonalContact':
        case 'OrganizationContact':
        case 'ImplicitContact':
        case 'Guest':
        case 'Unknown':
            return 'ExternalMailbox';
        default:
            return contactType;
    }
}
